import { render, staticRenderFns } from "./BroadcastTemplates.vue?vue&type=template&id=02b95583"
import script from "./BroadcastTemplates.vue?vue&type=script&lang=js"
export * from "./BroadcastTemplates.vue?vue&type=script&lang=js"
import style0 from "./BroadcastTemplates.vue?vue&type=style&index=0&id=02b95583&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports